import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Component from '../../components/AscComponent';
import CommonTable from '../Elements/Table/CommonTable';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import VocHistoryDeleteModal from './VocHistoryDeleteModal';
import moment from 'moment';
import ButtonSpeechBubble from "../Elements/AscElements/SetButtonWithSpeechBubble";

/**
 * VoC分析作成履歴 一覧（ユーザー管理画面と同形式のテーブル）
 * 対象テーブル: ht50_voc_analysis_report
 * 表示列: ステータス, 作成日時, メモ, レポート
 */
export default class VocHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: this.getColumnsData(),
      data: [],
      pageSize: 20,
      loading: false,
      sorted: [{ id: 'id', desc: true }],
      pageCount: 0,
      filtered: [],
      selectedData: [],
      show: false,
      modalType: null,
    };
    // 権限チェック（アクセス権がない場合 Forbidden へ）
    if (!(props.currentPermission && props.currentPermission.read)) {
      alert(this.props.langText.Message.AuthCheckError);
      this.props.historyPush('/Forbidden');
    }
  }

  // 一覧表作成
  getColumnsData() {
    return [
      {
        Header: 'ステータス',
        accessor: 'status',
        width: this.props.boardWidth ? this.props.boardWidth.smedium : 200,
        disableFilters: true,
        Cell: ({ row }) => {
          const s = String(row.original.status || '').toUpperCase();
          let label = '';
          let className = 'voc-status-badge';
          if (s === 'COMPLETED') { label = this.props.langText.Body.VocStatusCompleted; className += ' completed'; }
          else if (s === 'RUNNING') { label = this.props.langText.Body.VocStatusRunning; className += ' running'; }
          else if (s === 'FAILED') { label = this.props.langText.Body.VocStatusFailure; className += ' failure'; }
          else { label = s; }
          return <span className={className}>{label}</span>;
        }
      },
      {
        Header: '作成日時',
        accessor: 'createdAt',
        width: this.props.boardWidth ? this.props.boardWidth.large : 260,
        disableFilters: true,
        Cell: ({ row }) => {
          const v = row.original.createdAt;
          try { return v ? moment(v).format('YYYY/MM/DD HH:mm:ss') : ''; } catch (_) { return ''; }
        }
      },
      {
        Header: this.props.langText.Body.VocAnalysisCategory || 'VoCカテゴリー',
        accessor: 'vocCategories',
        width: this.props.boardWidth ? this.props.boardWidth.xlarge : 400,
        disableFilters: true,
        Cell: ({ row }) => {
          try {
            const paramsJson = row.original.params_json;
            if (!paramsJson) return '';

            let params = {};
            if (typeof paramsJson === 'string') {
              params = JSON.parse(paramsJson);
            } else if (typeof paramsJson === 'object') {
              params = paramsJson;
            }

            const vocCategoryList = params.voc_category_list;
            if (!vocCategoryList || !Array.isArray(vocCategoryList) || vocCategoryList.length === 0) {
              return '';
            }

            // カテゴリ名をカンマ区切りで表示
            const categoryNames = vocCategoryList
              .filter(cat => cat && cat.category_name)
              .map(cat => cat.category_name)
              .join('、');

            // 長すぎる場合は省略
            const maxLength = 50;
            if (categoryNames.length > maxLength) {
              return (
                <span title={categoryNames}>
                  {categoryNames.substring(0, maxLength) + '...'}
                </span>
              );
            }

            return categoryNames;
          } catch (err) {
            console.error('VoCカテゴリー表示エラー:', err);
            return '';
          }
        }
      },
      {
        Header: 'メモ',
        accessor: 'memo',
        width: this.props.boardWidth ? this.props.boardWidth.xlarge : 400,
        disableFilters: true,
      },
      {
        Header: 'レポート',
        accessor: 'reportUrl',
        width: this.props.boardWidth ? this.props.boardWidth.medium : 160,
        disableFilters: true,
        Cell: ({ row }) => {
          const url = row.original.reportUrl;
          return url ? (
            <ButtonSpeechBubble
              key={`open-report-${row.original.id}`}
              size="sm"
              className={"control-button"}
              DisplayIcon={faFileAlt}
              onClick={(e) => this.handleOpenReport(e, row.original.id)}
              speechBubble={[
                <div key={`bubble-${row.original.id}`}>{this.props.langText.Body.VocReport}</div>
              ]}
            />
          ) : '';
        }
      },
    ];
  }

  handleOpenReport = async (e, ht50Id) => {
    e.preventDefault();
    try {
      // 【SEC-05 / #359】URLではなくレポートIDを渡し、署名対象はサーバ側でDBから決定させる
      const res = await this.ascAxios('post', `VocAnalysis/getReportSignedUrl`, { ht50_id: ht50Id });
      const finalUrl = res && res.data && (res.data.url || res.data);
      if (typeof finalUrl === 'string' && finalUrl.length > 0) {
        window.location.href = finalUrl;
      } else {
        this.showErrorObjectMessage({ message: 'GetDataError_Server' });
      }
    } catch (err) {
      console.error('handleOpenReport error:', err);
      this.showErrorObjectMessage(err);
    }
  }

  // データ取得（サーバーページング）
  fetchData = async (currentPageSize, currentPageIndex, sorted, filtered) => {
    try {
      this.setState({ loading: true });
      const pageSize = currentPageSize || this.state.pageSize;
      const page = (currentPageIndex || 0) + 1;
      const res = await this.ascAxios('post', `${this.reactContainerPath}/list`, { page, pageSize });
      const json = res && res.data ? res.data : { data: [], total: 0 };
      const pages = Math.ceil((json.total || 0) / pageSize);
      this.setState({ data: json.data || [], pageCount: pages, loading: false, pageSize, pageIndex: currentPageIndex || 0 });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      this.showErrorObjectMessage(err);
    }
  }

  // チェックボックス選択変更時のコールバック
  onSelectedDataChange = (selectedData) => {
    this.setState({ selectedData });
  }

  // 削除モーダル表示
  modalShow = (modalType) => (event) => {
    event.preventDefault();
    const { selectedData } = this.state;
    if (modalType === 'delete') {
      if (!Array.isArray(selectedData) || selectedData.length === 0) {
        return this.showErrorObjectMessage('User_ModalSelectError');
      }
    }
    this.setState({ show: true, modalType });
  }

  render() {
    return (
      <div className='VocHistory'>
        <Row>
          <Col xs={12} md={12}>
            <Button
              id='vochistory-delete'
              className='table-button'
              variant='default'
              size='sm'
              onClick={this.modalShow('delete')}
              hidden={!this.props.currentPermission.delete}
            >
              {this.props.langText.Body.DeleteTitle}
            </Button>
            <CommonTable
              state={this.state}
              tableHeight={this.props.tableHeight}
              tbodyHeight={(this.props.tableHeight || 600) - 30}
              propsPageIndex={this.state.pageIndex ? this.state.pageIndex : 0}
              columns={this.state.columns}
              data={this.state.data}
              pageSize={this.state.pageSize}
              loading={this.state.loading}
              onFetchData={this.fetchData}
              onSelectedDataChange={this.onSelectedDataChange}
              filtered={this.state.filtered}
              sorted={this.state.sorted}
              pageCount={this.state.pageCount}
              manual={true}
              showPagination={true}
              showCheckbox={true}
              showPageSize={true}
              showFilter={false}
              langText={this.props.langText && this.props.langText.Table}
            />
          </Col>
        </Row>
        {/* 削除確認モーダル: フェードアウトを効かせるため show=false でもツリーに残す */}
        {this.state.modalType === 'delete' && (
          <VocHistoryDeleteModal
            state={this.state}
            propSetState={this.propSetState}
            langText={this.props.langText}
            validationHandle={this.validationHandle}
            onClick={this.onClickHandle}
          />
        )}
      </div>
    );
  }

  // モーダルOK押下時の実処理
  onClickHandle = (modalType) => async () => {
    try {
      switch (modalType) {
        case 'delete': {
          const { selectedData } = this.state;
          const ids = selectedData.map(r => r.id);
          this.blockUI();
          await this.ascAxios('post', `${this.reactContainerPath}/delete`, { ids });
          alert(this.props.langText.Message.DataDeleteSuccess);
          // 先にモーダルを閉じてフェードアウトさせ、その後に一覧を更新
          this.unblockUI();
          this.setState({ show: false }, () => {
            // フェードアウト時間に合わせて少し待機してから再取得
            setTimeout(async () => {
              await this.fetchData(this.state.pageSize, this.state.pageIndex || 0);
              this.setState({ selectedData: [] });
            }, 300);
          });
          break;
        }
        default:
          return this.showErrorObjectMessage('ModalTypeError');
      }
    } catch (err) {
      console.error(err);
      this.showErrorObjectMessage(err);
    } finally {
      // 上で閉じる処理を行っているため、ここではUIブロックのみ安全側で解除
      this.unblockUI();
    }
  }

  // バリデーション（削除時は選択必須）
  validationHandle = (param) => {
    if (param === 'delete') {
      const { selectedData } = this.state;
      return Array.isArray(selectedData) && selectedData.length > 0;
    }
    return true;
  }
}


